import Model from 'models/Model';

import Distributor from 'models/sales/distributor/Model.Distributor';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';
import executeServerApi from 'assets/utils/server/ServerApi';
import { createPathFromRoute } from 'assets/utils/dom/UrlParsing';

export async function pricingDistributionMasterTemplateSaveApi(
  body: Api.Core.PricingDistributionMasterTemplate.Save.IRequest
): Promise<Api.Res<Api.Core.PricingDistributionMasterTemplate.Save.IResponse>> {
  const serverResponse = await executeServerApi<
    Api.Core.PricingDistributionMasterTemplate.Save.IRequest,
    Api.Core.PricingDistributionMasterTemplate.Save.IResponse,
    Api.Core.PricingDistributionMasterTemplate.Save.IHeaders
  >({
    method: body?.id ? HttpMethod.put : HttpMethod.post,
    url: '/api/ProductManagement/PricingDistributionMasterTemplate',
    body,
    headers: getDefaultHeaders(),
  });
  return serverResponse;
}

export async function pricingDistributionMasterTemplateDeleteApi(
  body: Api.Core.PricingDistributionMasterTemplate.Delete.IRequest
): Promise<Api.Res<Api.Core.PricingDistributionMasterTemplate.Delete.IResponse>> {
  const serverResponse = await executeServerApi<
    Api.Core.PricingDistributionMasterTemplate.Delete.IRequest,
    Api.Core.PricingDistributionMasterTemplate.Delete.IResponse,
    Api.Core.PricingDistributionMasterTemplate.Delete.IHeaders
  >({
    method: HttpMethod.delete,
    url: createPathFromRoute(
      '/api/ProductManagement/PricingDistributionMasterTemplate/:distributorId/:productEnhancementId',
      body
    ),
    headers: getDefaultHeaders(),
  });
  return serverResponse;
}
export async function pricingDistributionMasterTemplateListApi(
  body: Api.Core.PricingDistributionMasterTemplate.List.IRequest
): Promise<Api.Res<Api.Core.PricingDistributionMasterTemplate.List.IResponse>> {
  return await executeServerApi<
    Omit<Api.Core.PricingDistributionMasterTemplate.List.IRequest, 'distributorId' | 'productEnhancementId'>,
    Api.Core.PricingDistributionMasterTemplate.List.IResponse,
    Api.Core.PricingDistributionMasterTemplate.List.IHeaders
  >({
    method: HttpMethod.get,
    url: '/api/ProductManagement/PricingDistributionMasterTemplate',
    body,
    headers: getDefaultHeaders(),
  });
}

export default class PricingDistributionMasterTemplate
  extends Model<Model.IPricingDistributionMasterTemplate>({ icon: 'fas-cloud' })
  implements Model.Instance<Model.IPricingDistributionMasterTemplate>
{
  id: number;
  name: string;
  description?: string;

  constructor(
    data: Partial<Model.IPricingDistributionMasterTemplate> | Utils.FormData<Model.IPricingDistributionMasterTemplate>,
    language?: Locale.Languages
  ) {
    super({ distributor: Distributor }, language);
    this.update(data);
  }
  get displayInfo(): Model.DisplayInfo {
    return {
      id: this.id,
      title: this.name,
    };
  }

  static async list(body?: Api.Core.PricingDistributionMasterTemplate.List.IRequest) {
    const { payload, ...rest } = await pricingDistributionMasterTemplateListApi(body);
    return {
      ...rest,
      payload: payload && {
        data: payload.data?.map((it) => new PricingDistributionMasterTemplate(it)),
        count: payload.count,
      },
    };
  }
  async save() {
    return await pricingDistributionMasterTemplateSaveApi(this);
  }
  async delete() {
    return await pricingDistributionMasterTemplateDeleteApi({ id: this.id });
  }
}
